'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'image-polaroid';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8c4';
var svgPathData = 'M32 384l0 64 384 0 0-64-384 0zM416 64l-384 0 0 288 384 0 0-288zm32 288l0 128-448 0 0-448 448 0 0 320zM320 270.5l-96-84-96 84 0 1.5 192 0 0-1.5zM96 256l128-112 128 112 0 48-256 0 0-48zm16-136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faImagePolaroid = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;